import React from 'react'

import './CertificationInput.css'

// components
import InputField from '../../InputField/InputField.component'

// mui
import { Paper, Grid, IconButton } from '@mui/material'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const CertificationInput = ({ prefix, handleChange, name, expirationDate, handleRemove, errors, handleDateChange }) => {

    return (<Grid container spacing={4}>
        <Grid item xs={1}>
            <IconButton onClick={handleRemove}>
                <RemoveCircleIcon color='error' />
            </IconButton>
        </Grid>
        <Grid item xs={11}>
            <Paper variant='outlined' sx={{ padding: 2, marginBottom: 2}}>
                <div className='certification-input-row'>
                    <InputField 
                        id={`${prefix}.name`}
                        type="text"
                        placeholder="Name"
                        onChange={handleChange}
                        value={name}
                        isValid={errors['name']}
                    />
                </div>
                <div>
                    <InputField 
                        id={`${prefix}.expirationDate`}
                        type="date"
                        placeholder="Expiration Date"
                        onChange={handleDateChange}
                        value={expirationDate}
                        isValid={errors['expirationDate']}
                    />
                </div>
            </Paper>
        </Grid>
    </Grid>)
}

export default CertificationInput